export default {
      id: "pay-premium-save-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#pay-premium-save",
      toString: function () {
        return this.url;
      }
    }